import { Store, createStore } from 'vuex'
import axios from 'axios';
import { DateModel } from '@/models/dateModel';
import { exist } from 'joi';
import { DateTime } from 'luxon';
import luxon from 'luxon'
import _, { get, set } from 'lodash';
import { Status } from '../enums/realizationstatus'

let API_URL = 'https://plnnr.simplexconnect.nl';
if (process.env.NODE_ENV === 'development') {
    API_URL = 'http://localhost:3000'
}
if (window.location.href.includes('simplexplnnr-dev')) {
  API_URL = 'https://simplexplnnr-dev.azurewebsites.net'
}

const green = '#1AA38C'
const orange = '#F99300'
const blue = '#028CCA'
const red = '#D32F2F'

axios.interceptors.request.use(async (config) => {
  if (!config || !config.url || !config.url.endsWith('/login') ) {
    if (!config?.url?.endsWith('/settings') && !config?.url?.endsWith('settingslogin') && !config?.url?.endsWith('settingsloadinstances') && !config?.url?.endsWith('settingssaveinstance')) {
      await store.state.loginPromise;
    }
  }
  if (store.state.sessionId && config.headers) {
    config.headers['session-id'] = store.state.sessionId;
  }
  return config;
});

let resolveLoginPromise: any;

const store =  createStore({
  state: {
    loginPromise: new Promise((res) => resolveLoginPromise = res),
    sessionId: null as string | null,
    environment: null as string | null,
    employees: null as Array<any> | null,
    items: null as Array<any> | null,
    nacalculatie: [] as Array<any>,
    projects: null as Array<any> | null,
    newDates: [] as Array<DateModel>,
    loading: 0 as number,
    currentEmployee: null as string | null,
    attrs: [] as Array<any>,
    disabledDates: [] as any,
    error: null as { message: string, id: number } | null,
    selectedProject: null as string | null,
    selectedItem: null as string | null,
    selectedProjectFase: null as string | null,
    description: null as string | null,
    settingsAccessToken: null as any | null,
    instances: null as Array<any> | null,
    ess: false as Boolean,
    showDatePopup: false as Boolean,
    datePopupDates: [] as Array<any>,
    snackbarMessage: '' as string,
    showSnackbar: false as Boolean,
    deleteOrEditLoading: false as Boolean,
    showNacalcUpdatePopup: false as Boolean,
    showOTPCodePopup: false as Boolean,
    fromProject: false as Boolean,
    colors: [] as Array<any> | null,
    timeFromError: 16 as number,
    timeToPartial: 4 as number,
    useProjectFase: false as Boolean,
    projectFases: [] as Array<any> | null,
    dimension1: null as string | null,
    closedDates: [] as Array<any> | null,
    maxBookingHours: 0 as number,
  },
  getters: {
  },
  mutations: {
    addDate(state, payload) {
      if (state.currentEmployee && !state.fromProject) {
        let TotalHours = 0
        for (let date of state.datePopupDates) {
          if (date.MedewerkerCode === state.currentEmployee) {
            TotalHours += date.Aantal;
          }
        }
        if (state.maxBookingHours != 0 && TotalHours >= state.maxBookingHours) {
          state.error = { message: `Op ${(payload.date.getDate().toString()).padStart(2, '0')}-${((payload.date.getMonth() + 1).toString()).padStart(2, '0')}-${payload.date.getFullYear()} is al ${state.maxBookingHours}+ uur geboekt. Je mag deze dag niet selecteren.`, id: Date.now() }
          return;
        }
      }

      let newDateModel = {
        date: payload.date, 
        description: `${(payload.date.getDate().toString()).padStart(2, '0')}-${((payload.date.getMonth() + 1).toString()).padStart(2, '0')}-${payload.date.getFullYear()}`, 
        status: Status.init} as DateModel;
      state.newDates.push(newDateModel);
      state.newDates = state.newDates.sort((a, b) => {
        return a.date < b.date ? -1 : 1;
      });
      state.error = { message: '', id: Date.now() }
      const disabledAttrs = state.attrs.filter(x => x.key === 'disabled-dates');
      state.attrs = state.attrs.filter(x => x.key !== 'disabled-dates');
      let attr = state.attrs.filter(x =>  {
          return (
                   x.dates.getFullYear() === payload.date.getFullYear() 
                && x.dates.getMonth() === payload.date.getMonth()
                && x.dates.getDate() === payload.date.getDate()
                )
        }
      );
      if (attr && attr.length) {
        attr[0].highlight.style.background = green;
        attr[0].highlight.style['background-color'] = green
      }
      state.attrs.push(...disabledAttrs);
      state.showDatePopup = false
    },
    deleteDate(state, payload) {
      if (!state.currentEmployee && !state.fromProject) {
        state.error = { message: 'Kies eerst een medewerker', id: Date.now() };
        return;
      }
      if (!state.selectedProject && state.fromProject) {
        state.error = { message: 'Kies eerst een project', id: Date.now() };
        return;
      }
      state.attrs = state.attrs.filter(x => x.key !== 'disabled-dates');
      state.newDates = state.newDates.filter(x =>
        !(x.date.getFullYear() === payload.date.getFullYear() &&
          x.date.getMonth() === payload.date.getMonth() &&
          x.date.getDate() === payload.date.getDate())
      );
      state.attrs = state.attrs.filter(x =>
        !(x.dates.getFullYear() === payload.date.getFullYear() &&
          x.dates.getMonth() === payload.date.getMonth() &&
          x.dates.getDate() === payload.date.getDate())
      );
      handleNacalculatie({ state }, { resetDates: false });
      state.error = { message: '', id: Date.now() };
      state.showDatePopup = false;
    },
    clickDate(state, payload) {
      if (!state.currentEmployee && !state.fromProject) {
        state.error = { message: 'Kies eerst een medewerker', id: Date.now() };
        return;
      }
      if (!state.selectedProject && state.fromProject) {
        state.error = { message: 'Kies eerst een project', id: Date.now() };
        return;
      }
      if (state.closedDates && state.closedDates.includes(DateTime.fromJSDate(payload.date).toFormat('yyyy-MM-dd'))) {
        state.error = { message: 'Dit is een sluitingsdag, boeken is niet mogelijk', id: Date.now() };
        return;
      }

      const disabledAttrs = state.attrs.filter(x => x.key === 'disabled-dates');
      state.attrs = state.attrs.filter(x => x.key !== 'disabled-dates');

      let existing = state.newDates?.filter(x => {
        return x.date.getFullYear() === payload.date.getFullYear() 
            && x.date.getMonth() === payload.date.getMonth()
            && x.date.getDate() === payload.date.getDate()
      });
      if (existing && existing.length > 0) { // delete date
        // remove from dates
        state.newDates = state.newDates?.filter(x => {
          return x.date.getFullYear() !== payload.date.getFullYear() 
            || x.date.getMonth() !== payload.date.getMonth()
            || x.date.getDate() !== payload.date.getDate()
        }).sort((a, b) => {
          return a.date < b.date ? -1 : 1;
        });
        // remove from calendar
        state.attrs = state.attrs.filter(x =>  {
          return (x.highlight.style.background === orange
              || x.highlight.style.background === blue
              || x.highlight.style.background === red
              ||  (    x.dates.getFullYear() !== payload.date.getFullYear() 
                    || x.dates.getMonth() !== payload.date.getMonth()
                    || x.dates.getDate() !== payload.date.getDate()
                  )
              || x.amount
            )
        })
        // set back to blue or orange when necessary
        let attr = state.attrs.filter(x =>  {
          return (
                   x.dates.getFullYear() === payload.date.getFullYear() 
                && x.dates.getMonth() === payload.date.getMonth()
                && x.dates.getDate() === payload.date.getDate()
                )
          }
        );
        if (attr && attr.length) {
          if (attr[0].amount) {
            const colorToSet = getColor(state, attr[0].amount);
            attr[0].highlight.style.background = colorToSet;
            attr[0].highlight.style['background-color'] = colorToSet;
          }
        }
        if (state.closedDates && state.closedDates.length > 0) {
          state.attrs.push(...disabledAttrs);
        }
        state.error = { message: '', id: Date.now() }
      } else { // add date
        // first check on existing date in calendar
        let existing = state.attrs.filter(x => {
          return (
            (
                 x.dates.getFullYear() === payload.date.getFullYear() 
              && x.dates.getMonth() === payload.date.getMonth()
              && x.dates.getDate() === payload.date.getDate()
            ) 
            && 
            (
              x.hasnacalc == true
            )
          )
        });
        if (existing && existing.length > 0) {
          state.datePopupDates = state.nacalculatie?.filter(x => {
            return (DateTime.fromISO(x.Datum).year === payload.date.getFullYear() 
                && DateTime.fromISO(x.Datum).month === payload.date.getMonth() + 1
                && DateTime.fromISO(x.Datum).day === payload.date.getDate())
          });
          state.showDatePopup = true;
          state.attrs.push(...disabledAttrs);
          return;
        }
        let newDateModel = {
          date: payload.date, 
          description: `${(payload.date.getDate().toString()).padStart(2, '0')}-${((payload.date.getMonth() + 1).toString()).padStart(2, '0')}-${payload.date.getFullYear()}`, 
          status: Status.init} as DateModel;
        state.newDates.push(newDateModel);
        state.newDates = state.newDates.sort((a, b) => {
          return a.date < b.date ? -1 : 1;
        });
        state.error = { message: '', id: Date.now() }
        // add to calendar
        state.attrs.push({
          key: DateTime.fromJSDate(payload.date).toFormat('yyyy-MM-dd'),
          highlight: {
            style: {
              background: green,
              'background-color': green
            },
            contentStyle: {
              color: 'White'
            },
            fillMode: 'solid'
          },
          dates: payload.date
        })
        // disabled-dates terugplaatsen
        state.attrs.push(...disabledAttrs);
        state.error = { message: '', id: Date.now() }
      }
    }
  },
  actions: {
    async login(ctx, payload) {
      ctx.state.loginPromise = new Promise((res) => resolveLoginPromise = res);
      try {
        const res = await axios.post(`${API_URL}/login`, payload);
        ctx.state.sessionId = res.data.sessionId;
        ctx.state.ess = res.data.ess;
        ctx.state.colors = res.data.colors;
        ctx.state.fromProject = res.data.fromProject;
        ctx.state.useProjectFase = res.data.useProjectFase;

        if (res.data.showOtpDialog) {
          ctx.state.showOTPCodePopup = true;
        }
        if (res.data.timeFromError) {
          const hours = res.data.timeFromError.split(':')[0] * 1;
          const minutes = res.data.timeFromError.split(':')[1] * 1;
          ctx.state.timeFromError = Math.round((hours + (minutes / 60)) * 60) / 60
        }
        if (res.data.timeToPartial) {
          const hours = res.data.timeToPartial.split(':')[0] * 1;
          const minutes = res.data.timeToPartial.split(':')[1] * 1;
          ctx.state.timeToPartial = Math.round((hours + (minutes / 60)) * 60) / 60
        }
        if (res.data.maxBookingHours) {
          ctx.state.maxBookingHours = res.data.maxBookingHours * 1;
        }
      } catch (e: any) {
        console.error(e)
        return e.response.status
      }
      resolveLoginPromise();
    },
    async getEmployees(ctx) {
      if (ctx.state.showOTPCodePopup) {
        return;
      }
      ctx.state.loading++
      const res = await axios.get(`${API_URL}/getEmployees`)
      ctx.state.employees = res.data;
      if (ctx.state.ess) {
        ctx.dispatch('setEmployee', { employee: res.data[0].Medewerker, resetDates: true })
      }
      ctx.state.loading--
    },
    async getItems(ctx) {
      if (ctx.state.showOTPCodePopup) {
        return;
      }
      ctx.state.loading++
      const res = await axios.get(`${API_URL}/getItems`)
      ctx.state.items = res.data;
      ctx.state.loading--
    },
    async getProjects(ctx) {
      if (ctx.state.showOTPCodePopup) {
        return;
      }
      ctx.state.loading++
      const res = await axios.get(`${API_URL}/getProjects`)
      ctx.state.projects = res.data;
      ctx.state.loading--;
    },
    async getProjectFases(ctx) {
      if (ctx.state.showOTPCodePopup) {
        return;
      }
      ctx.state.loading++;
      const res = await axios.get(`${API_URL}/getProjectFases?projectId=${ctx.state.selectedProject}`)
      ctx.state.projectFases = res.data;
      ctx.state.loading--;
    },
    async getSluitingsdagen(ctx) {
      if (ctx.state.showOTPCodePopup) {
        return;
      }
      ctx.state.loading++;
      try {
      const res = await axios.get(`${API_URL}/getSluitingsdagen`)
      ctx.state.closedDates = res.data.map((item: any) => item.Begin.split('T')[0]);
      } catch (e: any) {
        ctx.state.error = { message: e.response.data.message as string, id: Date.now() };
        ctx.state.closedDates = [];
      }
      if (ctx.state.closedDates && Array.isArray(ctx.state.closedDates)) {
        ctx.state.attrs.push({
          key: 'disabled-dates',
          dates: ctx.state.closedDates,
          excludeDates: false,
          customData: { disabled: true },
          highlight: {
            color: '#000000',
            contentStyle: {
              color: '#0000002f'
            },
            fillMode: 'light'
          }
        });
      }
      ctx.state.loading--;
    },
    async setProject(ctx, payload) {
      ctx.state.selectedProject = payload.project
      if (ctx.state.projects) {
        for (let project of ctx.state.projects) {
          if (project.ProjectCode === payload.toString()) {
            ctx.state.description = project.Relatienaam;
          }
        }
      }
      // reset projectfase on selecting other project
      ctx.state.selectedProjectFase = null;
      
      if (!ctx.state.fromProject) {
        // we have both employee and project here, check for dimension1
        const selectedEmp = ctx.state.employees?.filter(x => {
          return x.Medewerker === ctx.state.currentEmployee
        })
        if (selectedEmp && selectedEmp.length > 0 && selectedEmp[0].Dim1) {
          ctx.state.dimension1 = selectedEmp[0].Dim1
        } else { // no dimension on employee found, check project
          const selectedPrj = ctx.state.projects?.filter(x => {
            x.ProjectCode === ctx.state.selectedProject
          })
          if (selectedPrj && selectedPrj.length > 0 && selectedPrj[0].Dim1) {
            ctx.state.dimension1 = selectedPrj[0].Dim1
          }
        }
        return;
      } else {
        ctx.state.loading++
        ctx.state.disabledDates = []
        // reset dates when necessary
        if (payload.resetDates) {
          ctx.state.newDates = [] as Array<DateModel>;
        }
        ctx.state.error = { message: '', id: Date.now() };
        const res = await axios.get(`${API_URL}/getNacalculatie?project=${encodeURIComponent(payload.project)}`)
        ctx.state.nacalculatie = res.data;
        handleNacalculatie(ctx, payload);
        ctx.state.disabledDates = [] // disable disabled dates (object is all disabled, array is none disabled)
        ctx.state.loading--
      }
    },
    async setItem(ctx, payload) {
      ctx.state.selectedItem = payload
    },
    async setProjectFase(ctx, payload) {
      ctx.state.selectedProjectFase = payload;
    },
    async setDescription(ctx, payload) {
      ctx.state.description = payload
    },
    async setEmployee(ctx, payload) {
      ctx.state.currentEmployee = payload.employee
      if (ctx.state.fromProject) {
        // we have both employee and project here, check for dimension1
        const selectedEmp = ctx.state.employees?.filter(x => {
          return x.Medewerker === ctx.state.currentEmployee
        })
        if (selectedEmp && selectedEmp.length > 0 && selectedEmp[0].Dim1) {
          ctx.state.dimension1 = selectedEmp[0].Dim1
        } else { // no dimension on employee found, check project
          const selectedPrj = ctx.state.projects?.filter(x => {
            x.ProjectCode === ctx.state.selectedProject
          })
          if (selectedPrj && selectedPrj.length > 0 && selectedPrj[0].Dim1) {
            ctx.state.dimension1 = selectedPrj[0].Dim1
          }
        }
        return;
      }
      ctx.state.loading++
      ctx.state.disabledDates = []
      // reset dates when necessary
      if (payload.resetDates) {
        ctx.state.newDates = [] as Array<DateModel>;
      }
      ctx.state.error = { message: '', id: Date.now() };
      
      const res = await axios.get(`${API_URL}/getNacalculatie?employee=${encodeURIComponent(payload.employee)}`)
      ctx.state.nacalculatie = res.data;
      handleNacalculatie(ctx, payload);

      ctx.state.disabledDates = [] // disable disabled dates (object is all disabled, array is none disabled)
      ctx.state.loading--
    },
    async saveToAFAS(ctx, payload) {
      if (ctx.state.newDates) {
        ctx.state.disabledDates = []
        const promises: Array<Promise<void>> = [];
        for(const newDate of ctx.state.newDates.filter(x => {return x.status === Status.init || x.status === Status.error})) {
          promises.push((async () => {
            newDate.status = Status.loading
            try{
              const res = await axios.post(`${API_URL}/saveToAFAS`, 
              {
                date: newDate.date, 
                projectId: ctx.state.selectedProject, 
                itemcode: ctx.state.selectedItem,
                employeeId: ctx.state.currentEmployee,
                description: ctx.state.description,
                begintime: payload.begintime,
                endtime: payload.endtime,
                projectFase: ctx.state.selectedProjectFase,
                dim1: ctx.state.dimension1
              })
              if (res.status == 201) {
                newDate.status = Status.saved
              }
            } catch(exc:any) {
              newDate.error = exc.response.data.message as string // leave as string for newDate.error, not store error
              newDate.status = Status.error
            }
          })().catch((e: any) => {
            console.error(`Unhandled error: ${e.message}`)
          }));
        }
        await Promise.all(promises);
      }
      if (!ctx.state.fromProject) {
        this.dispatch('setEmployee', {employee: ctx.state.currentEmployee, resetDates: false}) // force refresh of calendar
      } else {
        this.dispatch('setProject', {project: ctx.state.selectedProject, resetDates: false}) // force refresh of calendar
      }
    },
    async deleteNacalc(ctx, payload) {
      try{
        const res = await axios.post(`${API_URL}/deleteFromAFAS`, payload)
        if (res.status == 200) {
          // delete nacalc from local store
          ctx.state.datePopupDates = ctx.state.datePopupDates.filter(x => {
            return (x.Regelnummer !== payload.Regelnummer)
          });
          ctx.state.nacalculatie = ctx.state.nacalculatie.filter(x => {
            return (x.Regelnummer !== payload.Regelnummer)
          });

          if (ctx.state.datePopupDates && ctx.state.datePopupDates.length > 0) {
            // update amount in calender
            let dateInCalendar = ctx.state.attrs.filter(x => {
              return x.key === payload.Datum.split('T')[0]
            })
            const newAmount = ctx.state.datePopupDates.reduce((prev, curr) => {
              return {
                Aantal: prev.Aantal + curr.Aantal
              }
            })
            if (dateInCalendar && dateInCalendar.length > 0) {
              dateInCalendar[0].amount += newAmount.Aantal
              if (newAmount.Aantal) {
                const colorToSet = getColor(ctx.state, newAmount.Aantal);
                dateInCalendar[0].highlight.style.background = colorToSet;
                dateInCalendar[0].highlight.style['background-color'] = colorToSet;
              }
            }
          } else { // no rows left, filter in calendar
            ctx.state.attrs = ctx.state.attrs.filter(x => {
              return x.key !== payload.Datum.split('T')[0]
            })
            // hide edit screen
            ctx.state.showDatePopup = false
          }
        } else {
          if (res.data && res.data.message) {
            ctx.state.error = { message: res.data.message, id: Date.now() };
          } else {
            ctx.state.error = { message: 'Er is iets fout gegaan, probeer het later opnieuw', id: Date.now() };
          }
        }
      } catch(exc:any) {
        ctx.state.error = { message: exc.response.data.message as string, id: Date.now() }
      } finally {
        ctx.state.deleteOrEditLoading = false
      }
    },
    async updateNacalc(ctx, payload) {
      try {
        let dimension1 = null;
        const selectedEmp = ctx.state.employees?.filter(x => {
          return x.Medewerker === payload.MedewerkerCode
        })
        if (selectedEmp && selectedEmp.length > 0 && selectedEmp[0].Dim1) {
          dimension1 = selectedEmp[0].Dim1
        } else { // no dimension on employee found, check project
          const selectedPrj = ctx.state.projects?.filter(x => {
            x.ProjectCode === payload.ProjectId
          })
          if (selectedPrj && selectedPrj.length > 0 && selectedPrj[0].Dim1) {
            dimension1 = selectedPrj[0].Dim1
          }
        }
        if (dimension1) { // add to payload
          payload.dim1 = dimension1;
        }

        const res = await axios.post(`${API_URL}/updateInAFAS`, payload)
        ctx.state.showNacalcUpdatePopup = false
        if (!ctx.state.fromProject) {
          this.dispatch('setEmployee', {employee: payload.MedewerkerCode, resetDates: false, filterDates: payload.Datum}) // force refresh of calendar
        } else {
          this.dispatch('setProject', {project: payload.ProjectId, resetdates: false, filterDates: payload.Datum})
        }
        
      } catch (e: any) {
        ctx.state.error = { message: e.response.data.message as string, id: Date.now() }
      } finally {
        ctx.state.deleteOrEditLoading = false
        ctx.state.showNacalcUpdatePopup = false
      }
    },
    async setSnackbar(ctx, bool) {
      ctx.state.showSnackbar = bool;
    },
    async setShowDatePopup(ctx, bool) {
      ctx.state.showDatePopup = bool;
    },
    async setShowNacalcUpdatePopup(ctx, bool) {
      ctx.state.showNacalcUpdatePopup = bool;
    },
    async sendOTPCode(ctx, code) {
      ctx.state.loading++;

      try {
        console.log('activate otp')
        const res = await axios.post(`${API_URL}/activateOTP`, { code: code})
        console.log('activated otp')
        ctx.state.showOTPCodePopup = false;
        if (!ctx.state.employees) {  
          this.dispatch('getEmployees')
        }
        if (!ctx.state.projects) {
          this.dispatch('getProjects')
        }
        if (!ctx.state.items) {
          this.dispatch('getItems')
        }
        
      } catch (e: any) {
        ctx.state.error = { message: e.response.data.message as string, id: Date.now() }
      } finally {
        ctx.state.loading--;
      }

    },


    async settingsLogin(ctx, payload) {
      ctx.state.loading++
      try {
        const response = await axios.post(`${API_URL}/settingslogin`, payload);
        ctx.state.settingsAccessToken = response.data
      } catch (e: any) {
        console.error(e)
        ctx.state.error = {
          message: e?.response?.data?.message || e?.message || String(e),
          id: Date.now()
        };
      } finally {
        ctx.state.loading--
      }
    },
    async settingsLoadInstances(ctx) {
      ctx.state.loading++
      try {
        const response = await axios.post(`${API_URL}/settingsloadinstances`, { accessToken: ctx.state.settingsAccessToken })
        ctx.state.instances = response.data
      } catch (e: any) {
        ctx.state.error = {
          message: e?.response?.data?.message || e?.message || String(e),
          id: Date.now()
        };
      } finally {
        ctx.state.loading--
      }
    },
    async settingsSaveInstance(ctx, instance) {
      ctx.state.loading++;
      try{
        const response = await axios.post(`${API_URL}/settingssaveinstance`, _.cloneDeep(instance), {
          headers: {
            accessToken: ctx.state.settingsAccessToken.accessToken }
          }
        )
      } catch (e: any) {
        ctx.state.error = {
          message: e?.response?.data?.message || e?.message || String(e),
          id: Date.now()
        };
      } finally {
        ctx.state.loading--;
      }
    },
    setError(ctx, error) {
      ctx.state.error = { message: typeof error === 'string' ? error : (error?.response?.data?.message || error?.message || String(error)), id: Date.now() };
    }
    
  },
  modules: {
  }
})

function handleNacalculatie(ctx: any, payload: any) {
  ctx.state.attrs = []
  if (ctx.state.closedDates && Array.isArray(ctx.state.closedDates)) {
    ctx.state.attrs.push({
      key: 'disabled-dates',
      dates: ctx.state.closedDates,
      excludeDates: false,
      customData: { disabled: true },
      highlight: {
        color: '#000000',
        contentStyle: {
          color: '#0000002f'
        },
        fillMode: 'light'
      }
    });
  }
  if (ctx.state.nacalculatie && ctx.state.nacalculatie.length > 0) {
    for (let nacalc of ctx.state.nacalculatie) {
      const existing = ctx.state.attrs.filter((x: any) => {
        return x.key === nacalc.Datum.split('T')[0];
      });
      let colorToSet = blue;
      if (ctx.state.colors && ctx.state.colors.length > 0) {
        const colorSetting = ctx.state.colors.find((x: any) => x.itemcode === nacalc.Itemcode);
        if (colorSetting && colorSetting.color) {
          colorToSet = colorSetting.color;
        }
      }
      if (nacalc.Aantal >= ctx.state.timeFromError) {
        colorToSet = red;
      } else if (nacalc.Aantal <= ctx.state.timeToPartial) {
        colorToSet = orange;
      }

      if (existing && existing.length > 0) {
        existing[0].amount += nacalc.Aantal;
        colorToSet = getColor(ctx.state, existing[0].amount);
        existing[0].highlight.style.background = colorToSet;
        existing[0].highlight.style['background-color'] = colorToSet;
      } else {
        ctx.state.attrs.push({
          key: DateTime.fromISO(nacalc.Datum).toFormat('yyyy-MM-dd'),
          highlight: {
            style: {
              background: colorToSet,
              'background-color': colorToSet
            },
            contentStyle: {
              color: 'White'
            },
            fillMode: 'solid'
          },
          dates: DateTime.fromISO(nacalc.Datum).toJSDate(),
          amount: nacalc.Aantal,
          hasnacalc: true,
          projectcode: nacalc.ProjectId
        });
      }
    }
  }

  
  if (payload.resetDates === false) {
    const errorDates = ctx.state.newDates.filter((x: any) => { return x.status === Status.error; });
    for (let errorDate of errorDates) {
      ctx.state.attrs.push({
        key: DateTime.fromJSDate(errorDate.date).toFormat('yyyy-MM-dd'),
        highlight: {
          style: {
            background: green,
            'background-color': green
          },
          contentStyle: {
            color: 'White'
          },
          fillMode: 'solid'
        },
        dates: errorDate.date
      });
    }
  }

  if (payload.filterDates) {
    ctx.state.datePopupDates = ctx.state.nacalculatie?.filter((x: any) => {
      return (DateTime.fromISO(x.Datum).year === DateTime.fromISO(payload.filterDates).year
        && DateTime.fromISO(x.Datum).month === DateTime.fromISO(payload.filterDates).month
        && DateTime.fromISO(x.Datum).day === DateTime.fromISO(payload.filterDates).day);
    });
  }
}

function getColorsForItemCodes(state: any) {
  if (state.colors && state.colors.length > 0) {
    for(const date of state.attrs) {
      if (date.amount && date.amount < state.timeToPartial) {
        const nacalcs = state.nacalculatie.filter((x: any) => {
          return date.key === x.Datum.split('T')[0]
        }
        )
        if (nacalcs && nacalcs.length > 0) {
          let group = {} as any;
          for(const nacalc of nacalcs) {
            if (group[nacalc.Itemcode]) {
              group[nacalc.Itemcode].rows.push(nacalc)
            } else {
              group[nacalc.Itemcode] = { rows: [], itemcode: nacalc.Itemcode };
              group[nacalc.Itemcode].rows.push(nacalc);
            }
          }
          let selectedgroup = null as any;
          for (let groupitem in group) {
            group[groupitem].total = 0
            for(let groupitemrow of group[groupitem].rows) {
              group[groupitem].total += groupitemrow.Aantal
            }
            if (!selectedgroup) {
              selectedgroup = group[groupitem]
            }
            else if (group[groupitem].total > selectedgroup.total ) {
              selectedgroup = group[groupitem]
            }
          }
          const color = state.colors.filter((x: any) => {
            return x.itemcode === selectedgroup.itemcode
          })
          if (color && color.length > 0) {
            return color[0].color;
          }
        }
      }
    }
  }
}

function getColor(state: any, amount: number = 0) {
  let colorToSet = blue;
  const itemCodeColor = getColorsForItemCodes(state);
  if (itemCodeColor) {
    colorToSet = itemCodeColor;
  }
  if (amount <= state.timeToPartial) {
    colorToSet = orange;
  } else if (amount >= state.timeFromError) {
    colorToSet = red;
  }
  return colorToSet;
}

export default store
